<div class="dcp">
    <div class="header">
        <h2>Are you sure, you want to move this to sales order?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" (click)="closeDialog()" [disabled]="processLoading">Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="processLoading"
                (click)="renew_refill_process_order()">{{processLoading ? 'Processing...' : 'Confirm'}}</button>
        </div>
    </div>
</div>